/* Per-option price comparison; never guesses measurements from product names. */
if (!customElements.get('ghost-picker-unit-price')) {
  customElements.define('ghost-picker-unit-price', class extends HTMLElement {
    static observedAttributes = [
      'data-price',
      'data-label',
      'data-currency',
      'data-unit-price',
      'data-reference-value',
      'data-reference-unit'
    ];

    connectedCallback() {
      this.render();
    }

    attributeChangedCallback() {
      if (this.isConnected) this.render();
    }

    render() {
      this.hidden = true;
      this.textContent = '';

      const d = this.dataset;
      let value, unit;

      // Prefer configured Shopify unit pricing, even for name-only options.
      if (
        d.unitPrice !== undefined &&
        d.unitPrice !== '' &&
        Number(d.referenceValue) > 0 &&
        d.referenceUnit
      ) {
        value = Number(d.unitPrice) / Number(d.referenceValue);
        unit = d.referenceUnit;
      } else {
        const match = (d.label || '')
          .trim()
          .match(/^(\d+(?:[.,]\d+)?)\s*(ml|cl|l|mg|g|kg)$/i);

        if (
          !match ||
          !(Number(match[1].replace(',', '.')) > 0) ||
          d.price === undefined ||
          d.price === ''
        ) return;

        value = Number(d.price) / Number(match[1].replace(',', '.'));
        unit = match[2].toLowerCase();
      }

      if (!Number.isFinite(value) || value < 0) return;

      const currency = d.currency;
      if (!currency) return;

      try {
        const locale = document.documentElement.lang || 'en-GB';

        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        });

        // Shopify Liquid prices are supplied in hundredths.
        let text = formatter.format(value / 100);

        const smallestUnit =
          10 ** -formatter.resolvedOptions().maximumFractionDigits;

        // Avoid displaying a positive unit price as zero.
        if (value > 0 && value / 100 < smallestUnit / 2) {
          text = `<${formatter.format(smallestUnit)}`;
        }

        this.textContent = `${text}/${unit}`;
        this.hidden = false;
      } catch (_) {
        // Leave hidden if the currency cannot be formatted.
      }
    }
  });
}